import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  Button,
} from '@/components/ui';
import { Clock } from 'lucide-react';

interface SessionWarningDialogProps {
  open: boolean;
  countdownSeconds: number;
  onContinue: () => void;
}

export function SessionWarningDialog({
  open,
  countdownSeconds,
  onContinue,
}: SessionWarningDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onContinue(); }}>
      <DialogContent size="sm" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-amber-500" />
            Sesion inactiva
          </DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-2">
              <p>
                Tu sesion se cerrara automaticamente por inactividad en{' '}
                <span className="font-bold text-amber-600 tabular-nums text-base">
                  {countdownSeconds}
                </span>{' '}
                segundos.
              </p>
              <p>Haz clic en continuar para mantener tu sesion activa.</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onContinue}>
            Continuar trabajando
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
